import React from "react";
import usePatientNotes from "components/pages/transmissions/modal/detail/notes/patient_notes/usePatientNotes";

import { AccordionDetails, Button, OutlinedInput } from "@mui/material";

import {
  cancelPatientNotes,
  onPatientNotesChange,
  onPatientNotesFocus,
} from "app/store/transmission/slice/transmissionSlice";

const PatientNoteForm = ({ data }) => {
  const {
    currentPatientNote,
    patientNotesSubmitting,
    patientNotesFocused,
    theme,
    dispatch,
    handleNote,
  } = usePatientNotes(data);

  return (
    !data?.legacy && (
      <AccordionDetails className="view-pdf__details">
        <div className="view-pdf__notes-content">
          <OutlinedInput
            rows={3}
            multiline
            fullWidth
            className="view-pdf__notes-content--textarea"
            variant="outlined"
            id="standard-basic"
            data-text="patient-note-field"
            placeholder="Write patient notes here"
            value={currentPatientNote?.note || ""}
            onChange={(event) => {
              dispatch(
                onPatientNotesChange({
                  index: currentPatientNote.index,
                  value: event.target.value,
                })
              );
              dispatch(onPatientNotesFocus(true));
            }}
            // onFocus={() => dispatch(onPatientNotesFocus(true))}
            style={{
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.background.paper,
            }}
          />
          {patientNotesFocused && (
            <div className="view-pdf__button-container d-flex flex-column">
              <Button
                onClick={() => handleNote(false)}
                className="view-pdf__button mb-2"
                variant="contained"
                color="secondary"
                data-action="patient-note-save-button"
                disabled={
                  !patientNotesFocused ||
                  !currentPatientNote?.note?.trim() ||
                  patientNotesSubmitting ||
                  data?.legacy
                }
              >
                <span style={{ color: "white" }}>
                  {patientNotesSubmitting ? "Saving..." : "Save"}
                </span>
              </Button>
              <Button
                onClick={() =>
                  dispatch(
                    cancelPatientNotes({ expanded: false, focused: false })
                  )
                }
                className="view-pdf__button"
                variant="outlined"
                disabled={patientNotesSubmitting}
                color="secondary"
                data-action="patient-note-cancel-button"
              >
                Cancel
              </Button>
            </div>
          )}
        </div>
      </AccordionDetails>
    )
  );
};

export default PatientNoteForm;
